
  import React from "react"
  import Component from "/home/familiarv/Documentos/nic/budget-nicaragua/code/src/layouts/es.js"
  import data from "/home/familiarv/Documentos/nic/budget-nicaragua/code/.cache/json/layout-es.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/es.js